import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AddDeadline from "../../components/deadlines/addDeadline";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config";
import { createDeadlines, createDeadlinesReset } from "../../store/actions/deadlines/company";
import { FormattedMessage } from "react-intl";
import Page from "../../components/general/page";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

const DeadlinesCreateView = ({ pageRef }) => {
  const navigate = useNavigate();  
  const auth = useSelector((state) => state.auth);
  const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);
  const deadlinesCompany = useSelector((state) => state.deadlinesCompany);
  const dispatch = useDispatch();

  const myType = main.myType;
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const clientIdSelected = main.clientIdSelected;
  const companySelected = main.companySelected;
  const deadlines = main.deadlinesAccountant;

  const intl = useIntl();

  useEffect(() => {    
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  useEffect(() => {   
    if (deadlinesCompany?.createDeadline?.status?.ended) {
      navigate("/scadenze");     
      setTimeout(() => {
        dispatch(createDeadlinesReset());
      }, 300);
    }   
  }, [deadlinesCompany?.createDeadline?.status, navigate, dispatch]);

  const onConfirm = (requestBody) => {  
    dispatch(createDeadlines(requestBody));
  };

  const linkTsVisible = myType === "STUDIO" ? TSDIGITAL_PORTALE_PUBLIC_URL + "#/"  : null;
  const selectedCompanyName = company?.companies?.find((el) => el.id === clientIdSelected);

  return (auth && accountantSelected && companySelected) && (
    <Page
      pageRef={pageRef}
      activePage="/scadenze"
      className="contentStructure withFooter"
      style={{ boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.1)" }}
      title={<FormattedMessage id="deadlines.pages.create.title" />}
      subtitle={selectedCompanyName.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}
      backText={<FormattedMessage id="deadlines.pages.create.goBack" />}
      backUrl="/scadenze"
      backLocation={linkTsVisible}
    >
      <AddDeadline
        accountantSelected={accountantSelected}
        accountantIdSelected={accountantIdSelected}
        auth={auth}
        company={company}
        companySelected={companySelected}
        clientIdSelected={clientIdSelected}
        deadlines={deadlines}
        myType={myType}        
        onConfirm={(requestBody) => onConfirm(requestBody)}
      />
    </Page>
  );
};

export default DeadlinesCreateView;
